/**
 * Block-level variant visibility filter.
 * Hides [data-variant-filter] elements whose allowed IDs do not include the current variant.
 * Does NOT hide sibling blocks. Hides the outer .shopify-section only when every
 * direct child of .page-blocks is hidden.
 *
 * Theme note: jQuery_T4NT / swatch.js load via lazyload2 AFTER this file may init,
 * and select[name=id] is updated with .val() (no native change event).
 * So we must retry-bind variant:change and also watch history.replaceState.
 */
(function () {
  if (window.__variantSectionFilterInit) return;
  window.__variantSectionFilterInit = true;

  var lastVariantId = null;

  function parseIds(raw) {
    if (!raw) return [];
    return String(raw)
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function getCurrentVariantId() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}

    var select =
      document.querySelector('#product-select_ppr') ||
      document.querySelector('#cart-form_ppr [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('.js_sticky_sl');
    if (select && select.value) return String(select.value);

    var vidEl = document.querySelector('[data-vid]');
    if (vidEl && vidEl.getAttribute('data-vid')) {
      return String(vidEl.getAttribute('data-vid'));
    }

    return null;
  }

  function setBlockVisibility(el, variantId) {
    var allowed = parseIds(el.getAttribute('data-variant-filter'));
    if (!allowed.length) return;
    el.hidden = allowed.indexOf(String(variantId)) === -1;
  }

  function updateEmptySections() {
    var pageBlocksList = document.querySelectorAll('.shopify-section .page-blocks');
    for (var i = 0; i < pageBlocksList.length; i++) {
      var pageBlocks = pageBlocksList[i];
      var section = pageBlocks.closest
        ? pageBlocks.closest('.shopify-section')
        : null;
      if (!section) continue;

      var hasFilter = false;
      var children = pageBlocks.children;
      var allHidden = children.length > 0;

      for (var j = 0; j < children.length; j++) {
        var child = children[j];
        if (child.hasAttribute('data-variant-filter')) hasFilter = true;
        if (!child.hidden) allHidden = false;
      }

      if (!hasFilter) continue;
      section.hidden = allHidden;
    }
  }

  function updateAll(variantId) {
    if (window.Shopify && Shopify.designMode) return;
    if (!variantId) return;

    variantId = String(variantId);
    if (variantId === lastVariantId) return;
    lastVariantId = variantId;

    var nodes = document.querySelectorAll('[data-variant-filter]');
    for (var i = 0; i < nodes.length; i++) {
      setBlockVisibility(nodes[i], variantId);
    }
    updateEmptySections();
  }

  // Expose for theme custom.js / other listeners that already bind variant:change
  window.__variantSectionFilterUpdate = updateAll;

  function syncFromDom() {
    updateAll(getCurrentVariantId());
  }

  function bindJqueryVariantChange() {
    if (window.__variantSectionFilterJqueryBound) return true;
    if (!window.jQuery_T4NT) return false;

    jQuery_T4NT(document).on('variant:change', function (evt, variant) {
      if (variant && variant.id) updateAll(variant.id);
    });
    window.__variantSectionFilterJqueryBound = true;
    return true;
  }

  function waitForJqueryBind() {
    if (bindJqueryVariantChange()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (bindJqueryVariantChange() || attempts > 150) {
        clearInterval(timer);
      }
    }, 100);
  }

  function patchHistory() {
    if (window.__variantSectionFilterHistoryPatched) return;
    window.__variantSectionFilterHistoryPatched = true;

    function wrap(methodName) {
      var original = history[methodName];
      if (typeof original !== 'function') return;
      history[methodName] = function () {
        var result = original.apply(this, arguments);
        // replaceState updates ?variant= without firing popstate
        setTimeout(syncFromDom, 0);
        return result;
      };
    }

    wrap('replaceState');
    wrap('pushState');
    window.addEventListener('popstate', syncFromDom);
  }

  function bindDomFallbacks() {
    // Native change rarely fires (theme uses jQuery .val), but keep as backup
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'id') return;
      if (t.tagName !== 'SELECT' && t.tagName !== 'INPUT') return;
      if (t.value) updateAll(t.value);
    });

    // Swatch / option clicks
    document.addEventListener(
      'click',
      function (e) {
        var swatch = e.target.closest
          ? e.target.closest(
              '.nt-swatch, .swatch__list_js, [data-value], .js_sticky_sl, .ttip_nt'
            )
          : null;
        if (!swatch) return;
        setTimeout(syncFromDom, 50);
        setTimeout(syncFromDom, 200);
      },
      true
    );
  }

  function init() {
    syncFromDom();
    waitForJqueryBind();
    patchHistory();
    bindDomFallbacks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
